/**
 * This file contains the default configuration for the Concord site client. The
 * session refresh interval and data refresh interval are set to 15 minutes by
 * default. The base URL is set to the current environment's API URL.
 */
import type { ConfigType } from '../types';

const defaultConfig = {
  dev: {
    sessionRefreshInterval: 1000 * 60 * 15,
    dataRefreshInterval: 1000 * 60 * 15,
    baseUrl: 'https://localhost:4000',
  },
  test: {
    sessionRefreshInterval: 1000 * 60 * 15,
    dataRefreshInterval: 1000 * 60 * 15,
    baseUrl: 'https://api.test.concord.test',
  },
  feature: {
    sessionRefreshInterval: 1000 * 60 * 15,
    dataRefreshInterval: 1000 * 60 * 15,
  },
  stage: {
    sessionRefreshInterval: 1000 * 60 * 15,
    dataRefreshInterval: 1000 * 60 * 15,
    baseUrl: 'https://api.stage.concord.work',
  },
  prod: {
    sessionRefreshInterval: 1000 * 60 * 15,
    dataRefreshInterval: 1000 * 60 * 15,
    baseUrl: 'https://api.concord.tech',
  },
};
function getDefaultConfig() {
  const { MODE: mode } = import.meta.env;
  if (mode in defaultConfig && typeof mode === 'string') {
    return defaultConfig[mode as keyof typeof defaultConfig];
  }
  return {
    ...defaultConfig.feature,
    baseUrl: `https://api.${mode}.concord.work`,
  };
}

class Config implements Partial<ConfigType> {
  sessionRefreshInterval: number = 1000 * 60 * 15;
  dataRefreshInterval: number = 1000 * 60 * 15;
  baseUrl: string = '';

  setConfig(payload: Partial<ConfigType>) {
    Object.assign(this, payload);
  }
}

const config = new Config();
config.setConfig(getDefaultConfig());

export default config;
